import { render } from "./CharactorClover.vue?vue&type=template&id=172b2315"
import script from "./CharactorClover.vue?vue&type=script&lang=js"
export * from "./CharactorClover.vue?vue&type=script&lang=js"

import exportComponent from "/Users/apple/Documents/Programing/sonak/sonak_2023/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__